
(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.unl-font-serif{font-family:Mercury SSm A,Mercury SSm B,Georgia,serif!important}');
